/**
 * Temporary upgrade flow diagnostics — filter: [UpgradeFlow]
 */

export function logUpgradeFlow(
  event: string,
  detail?: Record<string, unknown>
): void {
  if (typeof window === 'undefined') return
  console.log('[UpgradeFlow]', event, detail ?? {})
}
